// Re-export from @wander/shared + configure web auth bridge
import { configureIntentRouterApi } from '@wander/shared/utils/intentRouter.js';

export * from '@wander/shared/utils/intentRouter.js';
export { default } from '@wander/shared/utils/intentRouter.js';

// Configure authenticated fetch for web (adds Bearer token from Supabase session)
const authenticatedFetch = async (url, options = {}) => {
  const headers = { ...options.headers };
  try {
    // Read token directly from localStorage to avoid getSession() hanging
    // when Supabase auth endpoint is slow or unreachable
    const storageKey = Object.keys(localStorage).find(k => k.startsWith('sb-') && k.endsWith('-auth-token'));
    if (storageKey) {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '{}');
      if (stored?.access_token) {
        headers['Authorization'] = `Bearer ${stored.access_token}`;
      }
    }
  } catch { /* proceed without auth */ }
  return fetch(url, { ...options, headers });
};

configureIntentRouterApi(authenticatedFetch);
